fetchTotalProducts();
async function fetchProducts(page) {
  let aux = []
  let response = await fetch(`/products.json?limit=250&page=${page}`);
  let products = await response.json();
  products = products.products.map(product => aux.push(product));
  return aux;
}

async function fetchTotalProducts(){
  bucle = true;
  let products = [];
  let inicio_fetch = 1;
  while (bucle) {
    aux = await fetchProducts(inicio_fetch);
    aux.map( element => products.push(element));
    if (aux.length == 0) {
      bucle = false;
    }
     inicio_fetch++;
  }
  const products_fetch = {
    products
  }
  console.log(products_fetch);
  window.localStorage.setItem('products_to_filter', JSON.stringify(products_fetch));
}
